import {
  IFreeDeliverySettings,
  IUpdateDeliverySettingsDTO,
  IUPSDeliverySettings,
} from '@/models/deliverySettings.model';
import { DeliverySettingsFormFields, TDeliverySettingsFormValues } from '../helpers';

class UpdateDeliverySettingsDTO implements IUpdateDeliverySettingsDTO {
  freeDelivery: IFreeDeliverySettings;

  upsDelivery: IUPSDeliverySettings;

  channelId: number;

  constructor({ channelId, freeDelivery, upsDelivery }: TDeliverySettingsFormValues & { channelId: number }) {
    this.channelId = channelId;
    this.freeDelivery = {
      isEnabled: freeDelivery[DeliverySettingsFormFields.IS_ENABLED],
      minimalOrderAmount: freeDelivery[DeliverySettingsFormFields.MIN_ORDER_AMOUNT],
      excludedStatesUS: freeDelivery[DeliverySettingsFormFields.EXCLUDED_STATES_USA],
      excludedStatesCA: freeDelivery[DeliverySettingsFormFields.EXCLUDED_STATES_CANADA],
      popupTitle: freeDelivery[DeliverySettingsFormFields.POPUP_TITLE],
      popupDescription: freeDelivery[DeliverySettingsFormFields.POPUP_DESCRIPTION],
    };

    this.upsDelivery = {
      isEnabled: upsDelivery[DeliverySettingsFormFields.IS_ENABLED],
      excludedStatesUS: upsDelivery[DeliverySettingsFormFields.EXCLUDED_STATES_USA],
      excludedStatesCA: upsDelivery[DeliverySettingsFormFields.EXCLUDED_STATES_CANADA],
      price: upsDelivery[DeliverySettingsFormFields.PRICE],
    };
  }
}

export default UpdateDeliverySettingsDTO;
